import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type LoginErrorPageProps = {
  error: Error;
};

export const LoginErrorPage: React.FC<LoginErrorPageProps> = ({ error }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let msg: string = t("errors.authError");
  if (
    // @ts-ignore
    error.errorSummary ===
    "Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently."
  ) {
    msg = t("errors.authLinkError");
  }
  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100vh",
        textAlign: "center",
        flexWrap: "nowrap",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <ErrorOutlineOutlinedIcon sx={{ fontSize: "40px", width: "200px", height: "200px" }} />
      <Typography>{msg}</Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <Button variant="outlined" onClick={() => navigate("/")}>
          {t("errors.Take_me_home")}
        </Button>
      </Box>
    </Box>
  );
};
